export enum ProductEnum {
    MAJETOK = 'majetok',
    TRAVEL = 'travel',
    KASKO = 'kasko',
    KASKO_KRUPOBITIE = 'kasko-krupobitie',
    PZP = 'pzp',
    ZODPOVEDNOST = 'zodpovednost',
    LIFE = 'life'
}